<sh-logs (saveAlert)="onSaveAlert($event)"></sh-logs>
<sh-alerts-editor-container #alertEditor></sh-alerts-editor-container>
